import React from "react";
import { Share2, Link2, Twitter, Linkedin } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function ShareButton({ title }) {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const copy = () => { navigator.clipboard.writeText(url); toast.success("Link copied to clipboard"); };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="share-btn" className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.12em] text-npst-navy hover:text-npst-gold transition-colors">
          <Share2 size={15} /> Share
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={copy} data-testid="share-copy"><Link2 size={14} className="mr-2" /> Copy link</DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"><Twitter size={14} className="mr-2" /> Share on X</a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"><Linkedin size={14} className="mr-2" /> Share on LinkedIn</a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function SectionTitle({ eyebrow, title, className = "" }) {
  return (
    <div className={className}>
      {eyebrow && (
        <div className="label-eyebrow text-npst-gold mb-3 flex items-center gap-3">
          <span className="h-px w-8 bg-npst-gold/70" aria-hidden="true" />{eyebrow}
        </div>
      )}
      <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-npst-ink tracking-tight">{title}</h2>
    </div>
  );
}

export function Disclaimer({ text }) {
  if (!text) return null;
  return (
    <div className="mt-8 p-5 bg-npst-bgAlt border border-npst-line rounded-md" data-testid="legal-disclaimer">
      <div className="label-eyebrow text-npst-gold mb-2">Public Information Disclaimer</div>
      <p className="text-sm text-npst-muted leading-relaxed">{text}</p>
    </div>
  );
}
